// Field schema for the admin Content panel.
// Each field has: section, path, label_fr/en, type, bilingual flag.
// Types: text, textarea, list, color, boolean.
// Bilingual fields store under `${path}.fr` and `${path}.en`.

export const CONTENT_SECTIONS = [
  {
    id: "brand",
    label_fr: "Marque",
    label_en: "Brand",
    fields: [
      { path: "brand.name", label_fr: "Nom de marque", label_en: "Brand name", type: "text" },
      { path: "brand.baseline_fr", label_fr: "Baseline (FR)", label_en: "Baseline (FR)", type: "textarea" },
      { path: "brand.baseline_en", label_fr: "Baseline (EN)", label_en: "Baseline (EN)", type: "textarea" },
    ],
  },
  {
    id: "contact",
    label_fr: "Coordonnées",
    label_en: "Contact",
    fields: [
      { path: "contact.phone", label_fr: "Téléphone affiché", label_en: "Displayed phone", type: "text" },
      { path: "contact.phoneHref", label_fr: "Lien d'appel (tel:)", label_en: "Call link (tel:)", type: "text", hint: "Laisser vide pour génération auto" },
      { path: "contact.whatsappHref", label_fr: "Lien WhatsApp", label_en: "WhatsApp link", type: "text", hint: "Laisser vide pour génération auto" },
      { path: "contact.email", label_fr: "Email affiché", label_en: "Displayed email", type: "text" },
      { path: "contact.emailHref", label_fr: "Lien email (mailto:)", label_en: "Email link", type: "text", hint: "Laisser vide pour génération auto" },
      { path: "contact.instagramHref", label_fr: "URL Instagram", label_en: "Instagram URL", type: "text" },
      { path: "contact.city_fr", label_fr: "Localisation (FR)", label_en: "City (FR)", type: "text" },
      { path: "contact.city_en", label_fr: "Localisation (EN)", label_en: "City (EN)", type: "text" },
    ],
  },
  {
    id: "theme",
    label_fr: "Thème (couleurs)",
    label_en: "Theme (colors)",
    fields: [
      { path: "theme.bg", label_fr: "Couleur de fond", label_en: "Background", type: "color" },
      { path: "theme.surface", label_fr: "Surface secondaire", label_en: "Secondary surface", type: "color" },
      { path: "theme.text", label_fr: "Texte principal", label_en: "Primary text", type: "color" },
      { path: "theme.muted", label_fr: "Texte secondaire", label_en: "Secondary text", type: "color" },
      { path: "theme.accent", label_fr: "Accent (or)", label_en: "Accent (gold)", type: "color" },
    ],
  },
  {
    id: "sections",
    label_fr: "Sections visibles",
    label_en: "Section visibility",
    fields: [
      { path: "sections.home_about", label_fr: "Accueil — À propos", label_en: "Home — About", type: "boolean" },
      { path: "sections.home_services", label_fr: "Accueil — Grille services", label_en: "Home — Service grid", type: "boolean" },
      { path: "sections.home_works", label_fr: "Accueil — Œuvres sélectionnées", label_en: "Home — Selected works", type: "boolean" },
      { path: "sections.home_cta_band", label_fr: "Accueil — Bande CTA", label_en: "Home — CTA band", type: "boolean" },
    ],
  },
  {
    id: "home_hero",
    label_fr: "Accueil — Hero",
    label_en: "Home — Hero",
    fields: [
      { path: "translations.fr.home.hero_overline", label_fr: "Sur-titre (FR)", label_en: "Overline (FR)", type: "text" },
      { path: "translations.en.home.hero_overline", label_fr: "Sur-titre (EN)", label_en: "Overline (EN)", type: "text" },
      { path: "translations.fr.home.hero_title_1", label_fr: "Titre ligne 1 (FR)", label_en: "Title line 1 (FR)", type: "text" },
      { path: "translations.en.home.hero_title_1", label_fr: "Titre ligne 1 (EN)", label_en: "Title line 1 (EN)", type: "text" },
      { path: "translations.fr.home.hero_title_2", label_fr: "Titre ligne 2 (FR) — accentué", label_en: "Title line 2 (FR) — accent", type: "text" },
      { path: "translations.en.home.hero_title_2", label_fr: "Titre ligne 2 (EN) — accent", label_en: "Title line 2 (EN) — accent", type: "text" },
      { path: "translations.fr.home.hero_sub", label_fr: "Sous-texte (FR)", label_en: "Subtext (FR)", type: "textarea" },
      { path: "translations.en.home.hero_sub", label_fr: "Sous-texte (EN)", label_en: "Subtext (EN)", type: "textarea" },
      { path: "translations.fr.home.hero_cta_primary", label_fr: "Bouton principal (FR)", label_en: "Primary CTA (FR)", type: "text" },
      { path: "translations.en.home.hero_cta_primary", label_fr: "Bouton principal (EN)", label_en: "Primary CTA (EN)", type: "text" },
      { path: "translations.fr.home.hero_cta_secondary", label_fr: "Bouton secondaire (FR)", label_en: "Secondary CTA (FR)", type: "text" },
      { path: "translations.en.home.hero_cta_secondary", label_fr: "Bouton secondaire (EN)", label_en: "Secondary CTA (EN)", type: "text" },
    ],
  },
  {
    id: "home_about",
    label_fr: "Accueil — À propos",
    label_en: "Home — About",
    fields: [
      { path: "translations.fr.home.about_overline", label_fr: "Sur-titre (FR)", label_en: "Overline (FR)", type: "text" },
      { path: "translations.en.home.about_overline", label_fr: "Sur-titre (EN)", label_en: "Overline (EN)", type: "text" },
      { path: "translations.fr.home.about_title", label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: "translations.en.home.about_title", label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: "translations.fr.home.about_body", label_fr: "Texte (FR)", label_en: "Body (FR)", type: "textarea" },
      { path: "translations.en.home.about_body", label_fr: "Texte (EN)", label_en: "Body (EN)", type: "textarea" },
      { path: "home.stats.years", label_fr: "Stat — Années", label_en: "Stat — Years", type: "text" },
      { path: "home.stats.projects", label_fr: "Stat — Projets", label_en: "Stat — Projects", type: "text" },
      { path: "home.stats.disciplines", label_fr: "Stat — Disciplines", label_en: "Stat — Disciplines", type: "text" },
    ],
  },
  {
    id: "home_services_section",
    label_fr: "Accueil — Grille services",
    label_en: "Home — Service grid",
    fields: [
      { path: "translations.fr.home.services_overline", label_fr: "Sur-titre (FR)", label_en: "Overline (FR)", type: "text" },
      { path: "translations.en.home.services_overline", label_fr: "Sur-titre (EN)", label_en: "Overline (EN)", type: "text" },
      { path: "translations.fr.home.services_title", label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: "translations.en.home.services_title", label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: "translations.fr.home.services_sub", label_fr: "Sous-titre (FR)", label_en: "Sub (FR)", type: "textarea" },
      { path: "translations.en.home.services_sub", label_fr: "Sous-titre (EN)", label_en: "Sub (EN)", type: "textarea" },
    ],
  },
  {
    id: "home_cta",
    label_fr: "Accueil — Bande CTA",
    label_en: "Home — CTA band",
    fields: [
      { path: "translations.fr.home.cta_overline", label_fr: "Sur-titre (FR)", label_en: "Overline (FR)", type: "text" },
      { path: "translations.en.home.cta_overline", label_fr: "Sur-titre (EN)", label_en: "Overline (EN)", type: "text" },
      { path: "translations.fr.home.cta_title", label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: "translations.en.home.cta_title", label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: "translations.fr.home.cta_sub", label_fr: "Sous-texte (FR)", label_en: "Sub (FR)", type: "textarea" },
      { path: "translations.en.home.cta_sub", label_fr: "Sous-texte (EN)", label_en: "Sub (EN)", type: "textarea" },
      { path: "translations.fr.home.cta_button", label_fr: "Bouton (FR)", label_en: "Button (FR)", type: "text" },
      { path: "translations.en.home.cta_button", label_fr: "Bouton (EN)", label_en: "Button (EN)", type: "text" },
    ],
  },
  // Services — base fields (label/tagline/description/highlights) for all
  // standard service slugs PLUS phototheque. The phototheque-specific extras
  // (embed_*, how_*) live in their own dedicated section below.
  ...["btp", "events", "sports", "corporate", "advertising", "training", "phototheque"].map((slug) => ({
    id: `services_${slug}`,
    label_fr: `Service — ${slug.toUpperCase()}`,
    label_en: `Service — ${slug.toUpperCase()}`,
    fields: [
      { path: `translations.fr.services.${slug}.label`, label_fr: "Nom affiché (FR)", label_en: "Label (FR)", type: "text" },
      { path: `translations.en.services.${slug}.label`, label_fr: "Nom affiché (EN)", label_en: "Label (EN)", type: "text" },
      { path: `translations.fr.services.${slug}.tagline`, label_fr: "Accroche (FR)", label_en: "Tagline (FR)", type: "text" },
      { path: `translations.en.services.${slug}.tagline`, label_fr: "Accroche (EN)", label_en: "Tagline (EN)", type: "text" },
      { path: `translations.fr.services.${slug}.description`, label_fr: "Description (FR)", label_en: "Description (FR)", type: "textarea" },
      { path: `translations.en.services.${slug}.description`, label_fr: "Description (EN)", label_en: "Description (EN)", type: "textarea" },
      { path: `translations.fr.services.${slug}.highlights`, label_fr: "Points clés (FR — un par ligne)", label_en: "Highlights (FR)", type: "list" },
      { path: `translations.en.services.${slug}.highlights`, label_fr: "Points clés (EN — un par ligne)", label_en: "Highlights (EN)", type: "list" },
    ],
  })),
  // Photothèque Event — extras (embed labels + "How it works" steps).
  // Editable individually so the admin can tweak the live-gallery framing
  // copy without touching the embed iframe itself.
  {
    id: "services_phototheque_extras",
    label_fr: "Service — PHOTOTHÈQUE (extras)",
    label_en: "Service — PHOTOTHEQUE (extras)",
    fields: [
      { path: "translations.fr.services.phototheque.embed_overline", label_fr: "Embed — Sur-titre (FR)", label_en: "Embed — Overline (FR)", type: "text" },
      { path: "translations.en.services.phototheque.embed_overline", label_fr: "Embed — Sur-titre (EN)", label_en: "Embed — Overline (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.embed_title", label_fr: "Embed — Titre (FR)", label_en: "Embed — Title (FR)", type: "text" },
      { path: "translations.en.services.phototheque.embed_title", label_fr: "Embed — Titre (EN)", label_en: "Embed — Title (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.embed_intro", label_fr: "Embed — Intro (FR)", label_en: "Embed — Intro (FR)", type: "textarea" },
      { path: "translations.en.services.phototheque.embed_intro", label_fr: "Embed — Intro (EN)", label_en: "Embed — Intro (EN)", type: "textarea" },
      { path: "translations.fr.services.phototheque.how_overline", label_fr: "Comment ça marche — Sur-titre (FR)", label_en: "How — Overline (FR)", type: "text" },
      { path: "translations.en.services.phototheque.how_overline", label_fr: "Comment ça marche — Sur-titre (EN)", label_en: "How — Overline (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.how_title", label_fr: "Comment ça marche — Titre (FR)", label_en: "How — Title (FR)", type: "text" },
      { path: "translations.en.services.phototheque.how_title", label_fr: "Comment ça marche — Titre (EN)", label_en: "How — Title (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.how_step_1_label", label_fr: "Étape 1 — Titre (FR)", label_en: "Step 1 — Label (FR)", type: "text" },
      { path: "translations.en.services.phototheque.how_step_1_label", label_fr: "Étape 1 — Titre (EN)", label_en: "Step 1 — Label (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.how_step_1_body", label_fr: "Étape 1 — Texte (FR)", label_en: "Step 1 — Body (FR)", type: "textarea" },
      { path: "translations.en.services.phototheque.how_step_1_body", label_fr: "Étape 1 — Texte (EN)", label_en: "Step 1 — Body (EN)", type: "textarea" },
      { path: "translations.fr.services.phototheque.how_step_2_label", label_fr: "Étape 2 — Titre (FR)", label_en: "Step 2 — Label (FR)", type: "text" },
      { path: "translations.en.services.phototheque.how_step_2_label", label_fr: "Étape 2 — Titre (EN)", label_en: "Step 2 — Label (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.how_step_2_body", label_fr: "Étape 2 — Texte (FR)", label_en: "Step 2 — Body (FR)", type: "textarea" },
      { path: "translations.en.services.phototheque.how_step_2_body", label_fr: "Étape 2 — Texte (EN)", label_en: "Step 2 — Body (EN)", type: "textarea" },
      { path: "translations.fr.services.phototheque.how_step_3_label", label_fr: "Étape 3 — Titre (FR)", label_en: "Step 3 — Label (FR)", type: "text" },
      { path: "translations.en.services.phototheque.how_step_3_label", label_fr: "Étape 3 — Titre (EN)", label_en: "Step 3 — Label (EN)", type: "text" },
      { path: "translations.fr.services.phototheque.how_step_3_body", label_fr: "Étape 3 — Texte (FR)", label_en: "Step 3 — Body (FR)", type: "textarea" },
      { path: "translations.en.services.phototheque.how_step_3_body", label_fr: "Étape 3 — Texte (EN)", label_en: "Step 3 — Body (EN)", type: "textarea" },
    ],
  },
  // Formations
  ...["essentials", "portrait", "advanced"].map((key) => ({
    id: `course_${key}`,
    label_fr: `Formation — ${key}`,
    label_en: `Course — ${key}`,
    fields: [
      { path: `translations.fr.courses.${key}.title`, label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: `translations.en.courses.${key}.title`, label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: `translations.fr.courses.${key}.description`, label_fr: "Description (FR)", label_en: "Description (FR)", type: "textarea" },
      { path: `translations.en.courses.${key}.description`, label_fr: "Description (EN)", label_en: "Description (EN)", type: "textarea" },
      { path: `courses.${key}.price`, label_fr: "Tarif", label_en: "Price", type: "text" },
      { path: `courses.${key}.duration_fr`, label_fr: "Durée (FR)", label_en: "Duration (FR)", type: "text" },
      { path: `courses.${key}.duration_en`, label_fr: "Durée (EN)", label_en: "Duration (EN)", type: "text" },
      { path: `courses.${key}.level_fr`, label_fr: "Niveau (FR)", label_en: "Level (FR)", type: "text" },
      { path: `courses.${key}.level_en`, label_fr: "Niveau (EN)", label_en: "Level (EN)", type: "text" },
    ],
  })),
  {
    id: "about_page",
    label_fr: "Page Studio",
    label_en: "About page",
    fields: [
      { path: "translations.fr.about_page.overline", label_fr: "Sur-titre (FR)", label_en: "Overline (FR)", type: "text" },
      { path: "translations.en.about_page.overline", label_fr: "Sur-titre (EN)", label_en: "Overline (EN)", type: "text" },
      { path: "translations.fr.about_page.title", label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: "translations.en.about_page.title", label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: "translations.fr.about_page.body_1", label_fr: "Paragraphe 1 (FR)", label_en: "Body 1 (FR)", type: "textarea" },
      { path: "translations.en.about_page.body_1", label_fr: "Paragraphe 1 (EN)", label_en: "Body 1 (EN)", type: "textarea" },
      { path: "translations.fr.about_page.body_2", label_fr: "Paragraphe 2 (FR)", label_en: "Body 2 (FR)", type: "textarea" },
      { path: "translations.en.about_page.body_2", label_fr: "Paragraphe 2 (EN)", label_en: "Body 2 (EN)", type: "textarea" },
      { path: "translations.fr.about_page.body_3", label_fr: "Paragraphe 3 (FR)", label_en: "Body 3 (FR)", type: "textarea" },
      { path: "translations.en.about_page.body_3", label_fr: "Paragraphe 3 (EN)", label_en: "Body 3 (EN)", type: "textarea" },
      { path: "translations.fr.about_page.v1_title", label_fr: "Valeur 1 — titre (FR)", label_en: "Value 1 title (FR)", type: "text" },
      { path: "translations.en.about_page.v1_title", label_fr: "Valeur 1 — titre (EN)", label_en: "Value 1 title (EN)", type: "text" },
      { path: "translations.fr.about_page.v1_body", label_fr: "Valeur 1 — texte (FR)", label_en: "Value 1 body (FR)", type: "textarea" },
      { path: "translations.en.about_page.v1_body", label_fr: "Valeur 1 — texte (EN)", label_en: "Value 1 body (EN)", type: "textarea" },
      { path: "translations.fr.about_page.v2_title", label_fr: "Valeur 2 — titre (FR)", label_en: "Value 2 title (FR)", type: "text" },
      { path: "translations.en.about_page.v2_title", label_fr: "Valeur 2 — titre (EN)", label_en: "Value 2 title (EN)", type: "text" },
      { path: "translations.fr.about_page.v2_body", label_fr: "Valeur 2 — texte (FR)", label_en: "Value 2 body (FR)", type: "textarea" },
      { path: "translations.en.about_page.v2_body", label_fr: "Valeur 2 — texte (EN)", label_en: "Value 2 body (EN)", type: "textarea" },
      { path: "translations.fr.about_page.v3_title", label_fr: "Valeur 3 — titre (FR)", label_en: "Value 3 title (FR)", type: "text" },
      { path: "translations.en.about_page.v3_title", label_fr: "Valeur 3 — titre (EN)", label_en: "Value 3 title (EN)", type: "text" },
      { path: "translations.fr.about_page.v3_body", label_fr: "Valeur 3 — texte (FR)", label_en: "Value 3 body (FR)", type: "textarea" },
      { path: "translations.en.about_page.v3_body", label_fr: "Valeur 3 — texte (EN)", label_en: "Value 3 body (EN)", type: "textarea" },
    ],
  },
  {
    id: "contact_page",
    label_fr: "Page Contact",
    label_en: "Contact page",
    fields: [
      { path: "translations.fr.contact_page.title", label_fr: "Titre (FR)", label_en: "Title (FR)", type: "text" },
      { path: "translations.en.contact_page.title", label_fr: "Titre (EN)", label_en: "Title (EN)", type: "text" },
      { path: "translations.fr.contact_page.sub", label_fr: "Sous-titre (FR)", label_en: "Sub (FR)", type: "textarea" },
      { path: "translations.en.contact_page.sub", label_fr: "Sous-titre (EN)", label_en: "Sub (EN)", type: "textarea" },
    ],
  },
  {
    id: "navigation",
    label_fr: "Navigation",
    label_en: "Navigation",
    fields: [
      { path: "translations.fr.nav.home", label_fr: "Accueil (FR)", label_en: "Home (FR)", type: "text" },
      { path: "translations.en.nav.home", label_fr: "Accueil (EN)", label_en: "Home (EN)", type: "text" },
      { path: "translations.fr.nav.services", label_fr: "Services (FR)", label_en: "Services (FR)", type: "text" },
      { path: "translations.en.nav.services", label_fr: "Services (EN)", label_en: "Services (EN)", type: "text" },
      { path: "translations.fr.nav.training", label_fr: "Formation (FR)", label_en: "Training (FR)", type: "text" },
      { path: "translations.en.nav.training", label_fr: "Formation (EN)", label_en: "Training (EN)", type: "text" },
      { path: "translations.fr.nav.about", label_fr: "Studio (FR)", label_en: "Studio (FR)", type: "text" },
      { path: "translations.en.nav.about", label_fr: "Studio (EN)", label_en: "Studio (EN)", type: "text" },
      { path: "translations.fr.nav.contact", label_fr: "Contact (FR)", label_en: "Contact (FR)", type: "text" },
      { path: "translations.en.nav.contact", label_fr: "Contact (EN)", label_en: "Contact (EN)", type: "text" },
      { path: "translations.fr.nav.order", label_fr: "Commander (FR)", label_en: "Order (FR)", type: "text" },
      { path: "translations.en.nav.order", label_fr: "Commander (EN)", label_en: "Order (EN)", type: "text" },
    ],
  },
];
